import Vue from 'vue';
import Router from 'vue-router';
import appConfig from '@/app.config'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/HomePage'),
      meta: {
        authRequired: true,
        title: 'Dashboard' + ' | ' + appConfig.title
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/LoginPage'),
      meta: {
        authRequired: false,
        title: 'Login' + ' | ' + appConfig.title,
      },
    },
    {
      path: '/logout',
      name: 'wyloguj',
      component: () => import('./views/LogoutPage'),
      meta: {
        authRequired: false,
        title: 'Wyloguj' + ' | ' + appConfig.title,
      },
    },
    {
      path: '/reset-password',
      name: 'resetowanie-hasła',
      component: () => import('./views/ResetPassword'),
      meta: {
        authRequired: false,
        title: 'Resetowanie hasła' + ' | ' + appConfig.title,
      },
    },
    {
      path: '/reset-password/reset/:token',
      name: 'zmiana-hasła',
      component: () => import('./views/ChangePassword'),
      meta: {
        authRequired: false,
        title: 'Zmiana hasła' + ' | ' + appConfig.title,
      },
    },
    {
      path: '/404',
      name: '404',
      meta: {
        authRequired: false,
        title: '404' + ' | ' + appConfig.title
      },
      component: require('./views/utility/404Page').default,
    },
    {
      path: '/500',
      name: '500',
      meta: {
        authRequired: false,
        title: '404' + ' | ' + appConfig.title
      },
      component: require('./views/utility/500Page').default,
    },
    {
      path: '/subaccount/add',
      name: 'dodaj-podopiecznego',
      component: () => import('./views/subaccount/SubaccountAdd'),
      meta: {
        authRequired: true,
        title: 'Dodaj podopiecznego' + ' | ' + appConfig.title
      }
    },
    {
      path: '/subaccount/profile/:id',
      name: 'profil-podopiecznego',
      component: () => import('./views/subaccount/SubaccountProfile'),
      meta: {
        authRequired: true,
        title: 'Profil podopiecznego' + ' | ' + appConfig.title
      }
    },
    {
      path: '/subaccount/list',
      name: 'lista-podopiecznych',
      component: () => import('./views/subaccount/SubaccountList'),
      meta: {
        authRequired: true,
        title: 'Lista podopiecznych' + ' | ' + appConfig.title
      }
    },
    {
      path: '/account/add',
      name: 'dodaj-pracownika',
      component: () => import('./views/account/AccountAdd'),
      meta: {
        authRequired: true,
        title: 'Dodaj pracownika' + ' | ' + appConfig.title
      }
    },
    {
      path: '/account/edit/:id',
      name: 'account-edit',
      component: () => import('./views/account/AccountEdit'),
      meta: {
        authRequired: true,
        title: 'Edycja pracownika' + ' | ' + appConfig.title
      }
    },
    {
      path: '/account/list',
      name: 'account-list',
      component: () => import('./views/account/AccountList'),
      meta: {
        authRequired: true,
        title: 'Lista pracowników' + ' | ' + appConfig.title
      }
    },
    {
      path: '/account/details/:id',
      name: 'account-details',
      component: () => import('./views/account/AccountProfile'),
      meta: {
        authRequired: true,
        title: 'Profil pracownika | ' + appConfig.title
      }
    },
    {
      path: '/guardian/list',
      name: 'guardian-list',
      component: () => import('./views/account/GuardianList'),
      meta: {
        authRequired: true,
        title: 'Lista opiekunów' + ' | ' + appConfig.title
      }
    },
    {
      path: '/guardian/profile/:id',
      name: 'guardian-profile',
      component: () => import('./views/account/GuardianProfile'),
      meta: {
        authRequired: true,
        title: 'Profil opiekuna' + ' | ' + appConfig.title
      }
    },
    {
      path: '/account/profile',
      name: 'profil-pracownika',
      component: () => import('./views/account/AccountProfile'),
      meta: {
        authRequired: true,
        title: 'Profil pracownika' + ' | ' + appConfig.title
      }
    },
    {
      path: '/import/list',
      name: 'import-list',
      component: () => import('./views/import/ImportList'),
      meta: {
        authRequired: true,
        title: 'Import danych z pliku' + ' | ' + appConfig.title
      }
    },
    {
      path: '/import/:id/operation',
      name: 'Operacje importu',
      component: () => import('./views/import/ImportOperationList'),
      meta: {
        authRequired: true,
        title: 'Operacje importu' + ' | ' + appConfig.title
      }
    },
    {
      path: '/report/all-operations',
      name: 'allOperationsReport',
      component: () => import('./views/report/AllOperationsReport'),
      meta: {
        authRequired: true,
        title: 'Raport: wszystkie operacje' + ' | ' + appConfig.title
      }
    },
    {
      path: '/report/balance-operations',
      name: 'balanceOperationsReport',
      component: () => import('./views/report/BalanceOperationsReport'),
      meta: {
        authRequired: true,
        title: 'Raport: salda kont' + ' | ' + appConfig.title
      }
    },
    {
      path: '/report/inactive-subaccount',
      name: 'inactiveSubaccountReport',
      component: () => import('./views/report/InactiveSubaccountReport'),
      meta: {
        authRequired: true,
        title: 'Raport: kont nieaktywnych' + ' | ' + appConfig.title
      }
    },
    {
      path: '/application/list',
      name: 'lista-wnioskow',
      component: () => import('./views/application/ApplicationList'),
      meta: {
        authRequired: true,
        title: 'Wnioski: lista' + ' | ' + appConfig.title
      }
    },
    {
      path: '/application/edit/:id',
      name: 'applicationEditAndPreview',
      component: () => import('./views/application/ApplicationEdit'),
      meta: {
        authRequired: true,
        title: 'Wnioski: edycja i podgląd' + ' | ' + appConfig.title
      }
    },
    {
      path: '/message/list/:messageCategory',
      name: 'lista-wiadomosci',
      component: () => import('./views/message/MessageList'),
      meta: {
        authRequired: true,
        title: 'Wiadomości' + ' | ' + appConfig.title
      }
    },
    {
      path: '/message/:messageCategory/:messageId',
      name: 'szczegoly-wiadomosci',
      component: () => import('./views/message/MessageDetails'),
      meta: {
        authRequired: true,
        title: 'Szczegóły wiadomości' + ' | ' + appConfig.title
      }
    },
    {
      path: '/message/:messageCategory/:messageId/edit',
      name: 'edycja-wiadomosci',
      component: () => import('./views/message/MessageEdit'),
      meta: {
        authRequired: true,
        title: 'Edycja wiadomości' + ' | ' + appConfig.title
      }
    },
    {
      path: '/system-application/list',
      name: 'system-application-list',
      component: () => import('./views/system-application/SystemApplicationList'),
      meta: {
        authRequired: true,
        title: 'Wnioski systemowe ' + ' | ' + appConfig.title
      }
    },
    {
      path: '/system-application/:id',
      name: 'system-application-details',
      component: () => import('./views/system-application/SystemApplicationDetails'),
      meta: {
        authRequired: true,
        title: 'Szczegóły wniosku systemowego' + ' | ' + appConfig.title
      }
    },
    {
      path: '/system-application/:id/edit',
      name: 'system-application-edit',
      component: () => import('./views/system-application/SystemApplicationEdit'),
      meta: {
        authRequired: true,
        title: 'Edycja wniosku systemowego' + ' | ' + appConfig.title
      }
    },
    {
      path: '/fundraising/list',
      name: 'Zbiórki',
      component: () => import('./views/fundraising/ListView'),
      meta: {
        authRequired: true,
        title: 'Zbiórki ' + ' | ' + appConfig.title
      }
    },
    {
      path: '/fundraising/:id',
      name: 'Szczegóły zbiórki',
      component: () => import('./views/fundraising/DetailsView'),
      meta: {
        authRequired: true,
        title: 'Szczegóły zbiórki ' + ' | ' + appConfig.title
      }
    },
    {
      path: '/invitation/list',
      name: 'invitation-list',
      component: () => import('./views/invitation/InvitationList'),
      meta: {
        authRequired: true,
        title: 'Szczegóły zaproszenia ' + ' | ' + appConfig.title
      }
    },
    {
      path: '/invitation/:id',
      name: 'invitation-details',
      component: () => import('./views/invitation/InvitationDetails'),
      meta: {
        authRequired: true,
        title: 'Szczegóły zaproszenia ' + ' | ' + appConfig.title
      }
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
      path: '*',
      redirect: '404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = to.meta.authRequired;
  const token = localStorage.getItem('token');
  if (token) {
    const tokenData = JSON.parse(atob(token.split('.')[1]));

    if (((Date.now() / 1000)) >= tokenData.exp) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }

  const loggedIn = localStorage.getItem('token');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  document.title = to.meta.title;
  next()
});

export default router;
